/**
 * Template padrão para funções para classes de API.
 */
class APITemplate {
  buildSuccessResponse({ value, message }) {
    return {
      status: 200,
      message,
      value,
    }
  }

  buildErrorResponse({ message, value = [], status = 500 }) {
    return {
      status,
      message,
      value,
    }
  }

  carregar() {
    throw new Error('Função para carregar ainda não foi implementada')
  }

  salvar() {
    throw new Error('Função para salvar ainda não foi implementada')
  }

  remover() {
    throw new Error('Função para remover ainda não foi implementada')
  }
}

export default APITemplate
